type FieldValidationError = {
  readonly field: unknown;
  readonly message: unknown;
};

const isFieldValidationError = (value: unknown): value is FieldValidationError =>
  typeof value === 'object' && value !== null && 'field' in value && 'message' in value;

export const getFieldErrorMessage = (body: unknown, field: string): string | undefined => {
  if (!body || typeof body !== 'object' || !('errors' in body)) {
    return;
  }

  const { errors } = body;

  if (!Array.isArray(errors)) {
    return;
  }

  for (const item of errors) {
    if (!isFieldValidationError(item) || item.field !== field || typeof item.message !== 'string') {
      continue;
    }

    return item.message;
  }
};
